import { Navigate, Outlet } from "react-router-dom";
import Header from "./Header";
import Sidebar from "./sidebar";

const ProtectedRouteLogin = () => {



    let token = false;

    const loginStatus = localStorage.getItem("currentUserLoginStatus")

    if (loginStatus) {

        if (JSON.parse(loginStatus)) {

            token = true
        }
    }

    //return token ? <> <Header /> <Outlet /> </> : <Navigate to="/" />;

    return token ? <>  <Outlet /> </> : <Navigate to="/" />;




};

export default ProtectedRouteLogin;
